import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../../components/Link';

const LearnMoreButton = ({ cta, className }) => {
  return (
    <Link
      variant={cta.variant}
      size='small'
      url={cta.url}
      className={className}
    >
      {cta.text}
    </Link>
  );
};

LearnMoreButton.propTypes = {
  cta: PropTypes.object,
  className: PropTypes.string
};

export default LearnMoreButton;
